/** A part's fill. Named by colour, not by meaning: the caller decides what each part stands for. */
export type MeterTone =
  | 'accent'
  | 'accent-soft'
  | 'rival'
  | 'green'
  | 'orange'
  | 'red'
  | 'violet'
  | 'violet-soft'
  | 'inverted'
  | 'inverted-soft'

export interface MeterPart {
  key: string
  value: number
  tone: MeterTone
  /** The legend's words after the count, e.g. "published"; already localised. A part without one stays out of the legend. */
  label?: string
}

/** Full literal fill classes, so Tailwind's scanner sees them. */
export const METER_TONE_FILL: Record<MeterTone, string> = {
  accent: 'bg-accent-blue',
  'accent-soft': 'bg-meter-accent-soft',
  rival: 'bg-series-rival',
  green: 'bg-accent-green',
  orange: 'bg-accent-orange',
  red: 'bg-accent-red',
  violet: 'bg-accent-violet',
  'violet-soft': 'bg-meter-violet-soft',
  inverted: 'bg-bg-inverted',
  'inverted-soft': 'bg-meter-inverted-soft',
}
